/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CountsByKey } from '../model';
// @ts-ignore
import { TotalCount } from '../model';
/**
 * PublicCommentsApi - axios parameter creator
 * @export
 */
export const PublicCommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * パブリックコメントの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCommentCount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public-comments/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パブリックコメントの発行者別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCommentCountsByPublisher: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public-comments/publishers/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicCommentsApi - functional programming interface
 * @export
 */
export const PublicCommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicCommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * パブリックコメントの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCommentCount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicCommentCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パブリックコメントの発行者別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicCommentCountsByPublisher(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountsByKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicCommentCountsByPublisher(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicCommentsApi - factory interface
 * @export
 */
export const PublicCommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicCommentsApiFp(configuration)
    return {
        /**
         * パブリックコメントの全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCommentCount(options?: any): AxiosPromise<TotalCount> {
            return localVarFp.getPublicCommentCount(options).then((request) => request(axios, basePath));
        },
        /**
         * パブリックコメントの発行者別カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCommentCountsByPublisher(options?: any): AxiosPromise<CountsByKey> {
            return localVarFp.getPublicCommentCountsByPublisher(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicCommentsApi - interface
 * @export
 * @interface PublicCommentsApi
 */
export interface PublicCommentsApiInterface {
    /**
     * パブリックコメントの全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCommentsApiInterface
     */
    getPublicCommentCount(options?: AxiosRequestConfig): AxiosPromise<TotalCount>;

    /**
     * パブリックコメントの発行者別カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCommentsApiInterface
     */
    getPublicCommentCountsByPublisher(options?: AxiosRequestConfig): AxiosPromise<CountsByKey>;

}

/**
 * PublicCommentsApi - object-oriented interface
 * @export
 * @class PublicCommentsApi
 * @extends {BaseAPI}
 */
export class PublicCommentsApi extends BaseAPI implements PublicCommentsApiInterface {
    /**
     * パブリックコメントの全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCommentsApi
     */
    public getPublicCommentCount(options?: AxiosRequestConfig) {
        return PublicCommentsApiFp(this.configuration).getPublicCommentCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パブリックコメントの発行者別カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicCommentsApi
     */
    public getPublicCommentCountsByPublisher(options?: AxiosRequestConfig) {
        return PublicCommentsApiFp(this.configuration).getPublicCommentCountsByPublisher(options).then((request) => request(this.axios, this.basePath));
    }
}
